import { initializeLoginCtrl } from "DMS/Controllers/loginController.js";
import { registerPublicDomain } from "DMS/Controllers/commonController.js";

registerPublicDomain();
initializeLoginCtrl();